<template>
  <div>
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-chip class="ma-2" color="teal darken-1" text-color="white">
            <v-avatar left>
              <v-icon small>mdi-office-building-marker-outline</v-icon>
            </v-avatar>
            <strong>widgets</strong> Properties
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-container>
          <v-tooltip top color="#004D40">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-text-field
                  background-color="teal lighten-5"
                  dense
                  label="Name"
                  placeholder="Name..."
                  filled
                  disabled
                  v-model="widget.name"
                ></v-text-field>
              </div>
            </template>
            <span v-text="widget.name"></span>
          </v-tooltip>

          <div
            id="widget-images"
            style="display: flex; justify-content: center;"
          >
            <vue-upload-multiple-image
              accept="image/jpeg, image/png, image/gif"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              :data-images="images"
              dragText="Drag one or more images here  / Arrastre una o varias imágenes aquí"
              browseText="or click to select them / o presione click para seleccionarlas"
              primaryText="Principal / Principal"
              markIsPrimaryText="Set as principal / Elegir como principal"
            ></vue-upload-multiple-image>
          </div>
          <!-- {{ getSlug(widget.name) }}-{{ imageIndex }} -->

          <v-switch
            dark
            dense
            v-model="widget.zoom"
            label="Open image(s) in modal"
            color="teal darken-1"
            hide-details
          ></v-switch>

          <br />

          <v-text-field
            dark
            dense
            label="Modal title"
            placeholder="Modal title"
            outlined
            v-model="widget.title"
          ></v-text-field>

          <v-text-field
            dark
            dense
            label="Modal HTML content"
            placeholder="Modal HTML content"
            outlined
            v-model="widget.html"
          ></v-text-field>

          <v-text-field
            dark
            dense
            label="Redirect to URL"
            placeholder="Redirect to URL"
            outlined
            v-model="widget.url"
          ></v-text-field>
        </v-container>
      </v-navigation-drawer>
    </v-card>
    <br />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  name: 'hObjectPropertiesComponent',
  components: {
    VueUploadMultipleImage
  },
  data() {
    return {
      images: [],
      imageIndex: 1
    }
  },
  props: {
    widget: {
      required: true,
      type: Object,
      default: {
        name: ''
      }
    }
  },
  methods: {
    uploadImageSuccess(formData, index, fileList) {
      // console.log('data', formData, index, fileList)
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(index, done, fileList) {
      // console.log('index', index, fileList)
      const r = confirm('remove image')
      if (r == true) {
        done()
      } else {
      }
    },
    editImage(formData, index, fileList) {
      // console.log('edit data', formData, index, fileList)
    },
    getSlug(str) {
      str = str.toLowerCase()
      return str.replace(/ /g, '-')
    }
  }
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-icon {
  color: #e0f2f1;
}

.v-list-item__title {
  color: #e0f2f1;
}

.v-list-item:hover {
  background-color: #00695c;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Widget/Properties.vue